import React, { useState } from "react";
import { ClassificationsGroup } from "../pastReview/ClassificationsGroup";
import { Box, Button, Collapse } from "@chakra-ui/react";
import { FiPlusCircle, FiMinusCircle } from "react-icons/fi";


interface CollapsibleClassificationProps {
  classificationData: string;
}

export const CollapsibleClassification = ({
  classificationData,
}: CollapsibleClassificationProps) => {
  const [show, setShow] = useState(false);

  const handleToggle = () => setShow(!show);

  return (
    <>
      <Button  variant="collapseButton" onClick={handleToggle} rightIcon={show? <FiMinusCircle /> : <FiPlusCircle />}>
        Original Classification
      </Button>
      <Collapse in={show}>
        {classificationData && classificationData !== null && (
          <Box flex="1" mb={6} margin={3}>
            <ClassificationsGroup
              classification={classificationData}
            />
          </Box>
        )}
      </Collapse>
    </>
  );
};
